export default (element: Element | null, hawkFallbackId: string): void => {
  // Set the linked element id on the haas widget so we can optionally hide it later
  if (element) {
    const currentIds = element.getAttribute('data-hawk-fallback-ids');
    const hawkFallbackIds = new Set(currentIds ? currentIds.split(',') : []);
    hawkFallbackIds.add(String(hawkFallbackId));
    element.setAttribute('data-hawk-fallback-ids', Array.from(hawkFallbackIds).join(','));
  }
};
